var render = function render(){var _vm=this,_c=_vm._self._c;return _c('authentication-layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"content"},[_c('p',{staticClass:"has-text-white"},[_vm._v(" Hi, you are being redirected to your business portal. ")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }